/* global $ */
import Cookies from 'js-cookie';

class Popup {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="Popup"]'),
      cookieName: `png_closePopup_${document.getElementsByTagName('html')[0].getAttribute('lang')}`,
      cookieExpireDays: 1,
      cookiePath: '/',
      timeout: 0,
      ...options
    };
  }

  init() {
    const { module, cookieName, timeout } = this.config;

    const setCookie = () => {
      $(module).modal('hide');

      Cookies.set(this.config.cookieName, 'true', {
        expires: this.config.cookieExpireDays,
        path: this.config.cookiePath
      });
    };

    if (module && !Cookies.get(cookieName)) {
      const closeButton = module.querySelector('[data-dismiss="modal"]');

      setTimeout(() => {
        $(module).modal('show');
      }, timeout);

      if (closeButton) {
        closeButton.addEventListener('click', setCookie.bind(this));
      }
    }
  }
}

export default Popup;
